import React, { useState, useEffect } from 'react'
import ReactWhatsapp from 'react-whatsapp'
import { AiOutlineClose, AiOutlineMinusSquare } from 'react-icons/ai'
import { BsFillPlusSquareFill, BsFillMinusSquareFill } from 'react-icons/bs'
import { useGlobalContext } from '../context'
import { Link } from 'react-router-dom'

import Buying from './Buying'


function Bag() {
    const { bag, amountHandle, total, totalItems, sizeHandle } = useGlobalContext();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    const onChange = (e, id, size) => {
        sizeHandle(e.target.value, id)
    }

    if (bag.length > 0) {
        return (
            <div className='bag'>
                <div className="container">
                    <div className="items">
                        {
                            bag.map((item) => {
                                const { id, name, image, sizes, price, inStock, amount, chossenSize } = item
                                return (
                                    <div className="item" key={id}>
                                        <AiOutlineClose className='remove-item' onClick={() => amountHandle('remove', id)} />
                                        <img src={image[0]} alt="" className="item-img" />
                                        <div className="item-info">
                                            <h2 className="item-name">{name}</h2>
                                            <label htmlFor="sizes" className='sizes-label'>Sizes:</label>
                                            <select
                                                name="sizes"
                                                id="sizes"
                                                className='sizes'
                                                onChange={(e) => onChange(e, id)}
                                            >
                                                {sizes.map((size, index) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            className="size"
                                                            value={size}
                                                            onClick={() => sizeHandle(id, size)}
                                                        >{size}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="amount">
                                            <AiOutlineMinusSquare className='amount-dec' onClick={() => amountHandle('dec', id)} />
                                            <h2 className='amount-number'>{amount}</h2>
                                            <BsFillPlusSquareFill className='amount-inc' onClick={() => amountHandle('inc', id)} />
                                        </div>
                                        <h3 className="item-price">{amount * price} <span>LE</span></h3>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className="total">
                        <div className="total-items">
                            <h3>Total Items <br /> <span>{totalItems}</span> items</h3>
                        </div>
                        <div className="total-price">
                            <h3>Total Price <br /> {total} <span>LE</span></h3>
                        </div>
                        <Link to="/buying" className="buy-now">
                            Buy Now
                        </Link>
                    </div>

                </div>
            </div >
        )
    }
    else {
        return (
            <div className='bag'>
                <div className="container">
                    <h2 className='empty'>Your bag is empty fill it please!</h2>
                </div>
            </div >
        )
    }


}

export default Bag